// export const baseURL = 'http://172.16.1.177:3007'
// export const ImageUrl = 'http://172.16.1.177:3007/images/'
// export const ImageUrl2 = 'http://172.16.1.177:3007/'


export const baseURL = 'https://staging.bidbuyzoom.com'
export const ImageUrl = 'https://staging.bidbuyzoom.com/images/'
export const ImageUrl2 = 'https://staging.bidbuyzoom.com'
      
// NjQwMTdiOTEwMmRlZmY2ZTNkOTA3MWUwOjkxMTUxMg == ð 
 
export const google_api_key = 'AIzaSyBNPYbsmeUKRDH6WgLqnmyR2C60kgjkqoQ'